var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBook = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1 3c0-.6.4-1 1-1h6a5 5 0 0 1 4 2 5 5 0 0 1 4-2h6c.6 0 1 .4 1 1v15c0 .6-.4 1-1 1h-7a2 2 0 0 0-2 2 1 1 0 1 1-2 0 2 2 0 0 0-2-2H2a1 1 0 0 1-1-1V3Zm10 14.5a4 4 0 0 0-2-.5H3V4h5a3 3 0 0 1 3 3v10.5Zm2 0a4 4 0 0 1 2-.5h6V4h-5a3 3 0 0 0-3 3v10.5Z",
  fill: "currentColor"
})));
export default SvgBook;